const isInPosDevice = () => !!window.ReactNativeWebView

export default isInPosDevice